import type { SVGProps } from 'react';

const SvgRangeRange = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M5 4c-.55 0-1 .45-1 1v4.59L2.29 11.3a.996.996 0 0 0 0 1.41L4 14.42v4.59c0 .55.45 1 1 1s1-.45 1-1v-5c0-.27-.11-.52-.29-.71l-1.29-1.29 1.29-1.29a1 1 0 0 0 .29-.71v-5c0-.55-.45-1-1-1zm16.71 7.29L20 9.58V4.99c0-.55-.45-1-1-1s-1 .45-1 1v5c0 .27.11.52.29.71l1.29 1.29-1.29 1.29a1 1 0 0 0-.29.71v5c0 .55.45 1 1 1s1-.45 1-1V14.4l1.71-1.71a.996.996 0 0 0 0-1.41z"
    />
  </svg>
);
export default SvgRangeRange;
